<template>
    <div class="container">
        <div class="header">
            <div class="heading">
                <img v-if="viewMode" class="backArrow" src="../../assets/backArrow.svg" @click="onBackClick"/>
                <p v-if="!viewMode" class="title">Delink Request</p>
                <p v-else class="title">{{agencyName}} <span class="subTitle">Email ID: {{agencyId}} </span> </p>
            </div>
            <button class="submitBtn" @click="handleSubmit">{{viewMode ? 'De-link' : 'Create request'}}</button>
        </div>
        <div class="form">
            <div v-if="apiErrorMessage" class="errorContainer"> 
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <div v-if="viewMode">
                <div  class="label">Entity Name*</div>
                <div class="content"> 
                    <input class="textbox" :disabled="true" v-model="entityName" placeholder="Enter here" />
                </div>
            </div>
            <div>
                <div  class="label">Entity Id*</div>
                <div class="content"> 
                    <input class="textbox" :disabled="viewMode || role == 'BRAND' || role == 'SELLER'" v-model="entityId" @blur="validateBrandId" placeholder="Enter here" />
                    <p v-if="fieldErrors?.brandId" class="label" style="color: red">{{fieldErrors.brandId}}</p>
                </div>
            </div>
            <div v-if="!viewMode">
                <div  class="label">Agency Email Id*</div>
                <div class="content">
                    <input class="textbox" :disabled="viewMode || role == 'AGENCY'" v-model="agencyId" @blur="validateAgencyId" placeholder="Enter here" />
                    <p v-if="fieldErrors?.agencyId" class="label" style="color: red">{{fieldErrors.agencyId}}</p>
                </div>
            </div>
            <div>
                <div  class="label">Delink Reason*</div>
                <div class="content">
                    <textarea class="textbox" :disabled="viewMode" style="height: 98px; resize: none" type="textarea" v-model="reason" @blur="validateReason" placeholder="Enter here" />
                    <p v-if="fieldErrors?.reason" class="label" style="color: red">{{fieldErrors.reason}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCookie } from "@/services/campaignService";
import { agencyBrandDeLink, delinkRequest } from "@/services/selfServeService";


export default ({
    name: 'Delink',
    props: {
        viewMode: Boolean,
        item: Object,
    },
    data() {
       return {
            entityId: this.item?.entityId?? '',
            entityName: this.item?.entityName ?? '',
            agencyId: this.item?.agencyId ?? '',
            agencyName: this.item?.agencyName ?? '',
            reason: this.item?.reason ?? '',
            fieldErrors: {
                brandId: '',
                agencyId: '',
                reason: ''
            },
            apiErrorMessage: '',
            role: ''
       } 
    },
    mounted() {
        this.role = getCookie('role');
        const userId = getCookie('userId')
        if(this.role == 'BRAND' || this.role == 'SELLER') this.entityId = userId;
        if(this.role == 'AGENCY') this.agencyId = userId;
    },
    methods: {
        validateBrandId() {
            const userIdPattern = /^[0-9]+$/;
            this.fieldErrors.brandId = !userIdPattern.test(this.entityId) ? 'Entity ID is invalid' : ''
        },
        validateAgencyId() {
            const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.fieldErrors.agencyId = !emailPattern.test(this.agencyId) ? 'Agency ID is invalid' : '';
        },
        validateReason() {
            this.fieldErrors.reason = (this.reason == "") ? 'Delink reason cannot be empty' : '';
        },
        validateForm() {
            this.validateBrandId();
            this.validateAgencyId();
            this.validateReason();
            if(this.fieldErrors.brandId || this.fieldErrors.agencyId || this.fieldErrors.reason) return false;
            return true;
        },
        handleSubmit() {
           if(!this.viewMode) {
                if(this.validateForm()) {
                    const payload = {
                        agencyId: this.agencyId,
                        brandId: this.entityId,
                        deLinkReason: this.reason
                    }
                    delinkRequest(payload)
                        .then(res => res.json())
                        .then(data => {
                            if(data.code == 200) {
                                this.$router.push('/')
                            } else {
                                this.apiErrorMessage = data?.errors?.[0] || data?.message
                            }
                        })
                        .catch(data => {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        })
                }
            } else {
                const payload = {
                    agencyId: this.item.agencyId,
                    brandId: this.item.entityId,
                    approvalStatus: 'APPROVED',
                    isDelink: true,
                }
                agencyBrandDeLink(payload)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.onBackClick()
                        } else {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    })
            }
        },
        onBackClick() {
            this.$emit('backClicked')
        }
    }
})
</script>

<style scoped>
.container {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}
.title{
    margin-left:20px;
}
.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}
.submitBtn {
    background: #2E31BE;
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9.5px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    border: none;
    height: 40px;
}
.form {
    display: flex;
    flex-direction: column;
    margin: 1%;
    text-align: start;
    background: #FFFFFF;
    padding: 22px 24px 36px;
    border-radius: 12px;
}
.content{
    height: 100%;
}
.textbox{
    width: 274px;
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    max-width: 246px;
}
.label{
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    margin-bottom: 12px;
    margin-top: 16px;
}
.textbox:disabled {
  background-color: #E0E0E0;
}
.backArrow {
    cursor: pointer;
}
.subTitle {
    font-size: 14px;
    font-weight: 600;
    color: #666666;
    margin-left: 8px;
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
</style>
